namespace SP {
    export interface Arrival {
        id: string;
        customerId: string;
        createUserId: string;
        sender: number;
        referenceNo: number;
        senderReferenceNo: number;
        timestamp: number;
        arrivalType: number;
        finished: boolean;
    }
}